module.exports = __webpack_public_path__ + "img/pollution_level_3.541401c4.png";